"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.SIZES = exports.ICONS = exports.DISPLAYS = exports.COLORS = exports.CABIN_CLASS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constant = require("../Carrier/constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TRANSLATION = _objectSpread(_objectSpread({}, _constant.TRANSLATION), {}, {
  layover: 'Layover',
  selfTransfer: 'Self-transfer',
  moreinfo: ' More info',
  heading: 'You may need to:',
  selfTransferNote1: '• Change terminals and recheck-in your baggage for your next flight.',
  selfTransferNote2: '• Apply a visa for your transiting country and final destinations.',
  selfTransferNote3: // eslint-disable-next-line max-len
  "• Rebook your flights if there is a disruption. This may result in additional costs and refunds aren't guaranteed.",
  selfTransferNote4: // eslint-disable-next-line max-len
  '• Take note of the different fare rules for each flight in your itinerary. They may be different for each airline.',
  via: 'via',
  selfTransferVia: 'Self-transfer Via',
  departureAirport: 'Departure Airport',
  protectionByStr: 'Connection protected by the',
  carrier: 'carrier',
  moreInfoLink: 'https://support.airasia.com/s/article/Any-Airlines-Self-transfer-at-the-connecting-airport?language=en_GB'
});

exports.TRANSLATION = TRANSLATION;
var CABIN_CLASS = _constant.CABIN_CLASS;
exports.CABIN_CLASS = CABIN_CLASS;
var COLORS = {
  greyDark: 'greyDark',
  secondary: 'secondary',
  neutral: 'neutral',
  orangeDarkMedium: 'orangeDarkMedium',
  orange: 'orange',
  blue: 'blue',
  black: 'black',
  tertiaryRed: '#8D1414'
};
exports.COLORS = COLORS;
var SIZES = {
  XSmall: 'XSmall',
  small: 'small',
  normal: 'normal',
  sub: 'sub'
};
exports.SIZES = SIZES;
var ICONS = {
  layover: 'ShuffleIcon',
  selfTransfer: 'TransferWithinAStationIcon',
  protectedBy: 'VerifiedUserIcon',
  origin: 'FlightIcon',
  stopover: 'RoomIcon',
  destination: 'TripOriginIcon',
  technicalStop: 'LocalGasStationIcon',
  ferry: 'DirectionsBoat'
};
exports.ICONS = ICONS;
var DISPLAYS = {
  inlineFlex: 'inlineFlex',
  flex: 'flex',
  block: 'block'
};
exports.DISPLAYS = DISPLAYS;